(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-closed-draw-defined.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-closed-draw-defined.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo;
const clx = svs.components.lbUtils.clx;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const _svs$components$marke = svs.components.marketplaceCompetition.overviewHero.common,
  CompetitionLogo = _svs$components$marke.CompetitionLogo,
  LoginButton = _svs$components$marke.LoginButton,
  TrixaButton = _svs$components$marke.TrixaButton;
const resolveCompetitionName = svs.components.marketplaceCompetition.helpers.resolveCompetitionName;
const _svs$components$marke2 = svs.components.marketplaceCompetition.overviewHero.helpers,
  capitalize = _svs$components$marke2.capitalize,
  ordinalNumber = _svs$components$marke2.ordinalNumber;
const _svs$components$marke3 = svs.components.marketplaceCompetition.overviewHero.hooks,
  useMobileQuery = _svs$components$marke3.useMobileQuery,
  useTrixa = _svs$components$marke3.useTrixa;
const _svs$components$marke4 = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState,
  IS_NOT_REGISTERED = _svs$components$marke4.IS_NOT_REGISTERED,
  HAS_NO_CURRENT_BET = _svs$components$marke4.HAS_NO_CURRENT_BET,
  HAS_CURRENT_BET = _svs$components$marke4.HAS_CURRENT_BET;
const UserNotLoggedIn = _ref => {
  let competition = _ref.competition;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    "aria-label": "Logga in f\xF6r att se dina resultat",
    className: "overview-hero-title"
  }, React.createElement("span", {
    "aria-hidden": "true"
  }, "Logga in f\xF6r att se"), React.createElement("span", {
    "aria-hidden": "true"
  }, "dina resultat")), React.createElement(LoginButton, {
    isVisible: true
  })));
};
const UserNotRegistered = _ref2 => {
  let competition = _ref2.competition,
    isMobile = _ref2.isMobile,
    showTrixa = _ref2.showTrixa;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "T\xE4vlingen har startat!")), !isMobile && React.createElement("div", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Men du kan ist\xE4llet t\xE4vla i antal kickar")), React.createElement(TrixaButton, {
    isVisible: !isMobile,
    onClick: showTrixa
  })));
};
const UserHasNoBet = _ref3 => {
  let competition = _ref3.competition,
    compName = _ref3.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Du deltar i ".concat(compName)))));
};
const UserHasBet = _ref4 => {
  var _competition$currentD;
  let competition = _ref4.competition;
  const _ref5 = (competition === null || competition === void 0 ? void 0 : competition.details) || {},
    firstDrawNumber = _ref5.firstDrawNumber,
    currentDrawNumber = _ref5.currentDrawNumber;
  const closeTime = (_competition$currentD = competition.currentDraw) !== null && _competition$currentD !== void 0 && _competition$currentD.regCloseTime ? formatDate(competition.currentDraw.regCloseTime, true, true) : null;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber + 1;
      return React.createElement("h2", {
        "aria-label": "Du har l\xE4mnat in spelet till ".concat(ordinalNumber(round), " omg\xE5ngen")
      }, React.createElement("span", {
        "aria-hidden": "true"
      }, "Du har l\xE4mnat in spelet till"), React.createElement("span", {
        "aria-hidden": "true"
      }, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("h2", null, "Du har l\xE4mnat in spelet f\xF6r omg\xE5ngen!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, currentGameTitle, closeTime && React.createElement("div", {
    className: "overview-hero-sub-small"
  }, "Spelet startar ".concat(capitalize(closeTime)))));
};
const CompetitionClosedDrawDefined = _ref6 => {
  let branding = _ref6.branding,
    competition = _ref6.competition,
    userState = _ref6.userState;
  const compName = resolveCompetitionName(competition);
  const isMobile = useMobileQuery();
  const _useTrixa = useTrixa(),
    _useTrixa2 = _slicedToArray(_useTrixa, 2),
    showTrixa = _useTrixa2[0],
    Trixa = _useTrixa2[1];
  const renderContentBasedOnUserState = state => {
    switch (state) {
      case IS_NOT_REGISTERED:
        return React.createElement(UserNotRegistered, {
          competition: competition,
          isMobile: isMobile,
          showTrixa: showTrixa
        });
      case HAS_NO_CURRENT_BET:
        return React.createElement(UserHasNoBet, {
          competition: competition,
          compName: compName
        });
      case HAS_CURRENT_BET:
        return React.createElement(UserHasBet, {
          competition: competition
        });
      default:
        return React.createElement(UserNotLoggedIn, {
          competition: competition
        });
    }
  };
  if (Trixa) {
    return React.createElement(Trixa, {
      active: true,
      branding: branding,
      classNames: "competition-overview-hero competition-closed-draw-defined"
    });
  }
  return React.createElement("div", {
    className: clx('competition-overview-hero competition-closed-draw-defined', userState)
  }, renderContentBasedOnUserState(userState));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionClosedDrawDefined', CompetitionClosedDrawDefined);

 })(window);